import { Form, FormInstance, InputNumber, Radio, Select } from 'antd';
import { FormProps } from 'antd/es/form/Form';
import { projectUsages } from 'const/project';
import usePickList from 'hooks/usePickList';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PickListValue } from 'types/PickList';

export interface ProjectInformationsFormType {
  isAncien: 'oui' | 'non';
  nature: string;
  usage: string;
  operation: string;
  surfaceVentileeRehabilitee: number;
  ancienneEnergieChauffage: string;
  nouvelleEnergieChauffage: string;
  surfaceChauffee: number;
  surfaceChauffeeRehabilitee: number;
}

interface ProjectInformationsFormProps
  extends FormProps<ProjectInformationsFormType> {
  formInstance: FormInstance<ProjectInformationsFormType>;
}

export default function ProjectInformationsForm({
  formInstance,
  ...props
}: ProjectInformationsFormProps) {
  const { t } = useTranslation();

  const operation = Form.useWatch('operation', formInstance);

  const { data: projectNatures } = usePickList(
    'dossiers',
    'chantier.natureTravaux',
  );
  // Le metier veut une liste statique pour le moment, NE PAS UTILISER CETTE LISTE
  // const { data: a } = usePickList('dossiers', 'site.usage');
  const { data: projectOperations } = usePickList('dossiers', 'typeOperation');
  const { data: newProjectEnergies } = usePickList(
    'dossiers',
    'batiment.nouvelleEnergieChauffage',
  );
  const { data: previewsProjectEnergies } = usePickList(
    'dossiers',
    'batiment.ancienneEnergieChauffage',
  );

  return (
    <Form<ProjectInformationsFormType>
      form={formInstance}
      layout={'vertical'}
      // className={'blue-form'}
      {...props}
    >
      <Form.Item<ProjectInformationsFormType>
        name={'isAncien'}
        label={t('add_dossier_project:isAncien')}
        rules={[{ required: true }]}
        required
      >
        <Radio.Group>
          <Radio value="oui">{t('global:yes')}</Radio>
          <Radio value="non"> {t('global:no')} </Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item<ProjectInformationsFormType>
        name={'nature'}
        label={t('add_dossier_project:nature')}
        rules={[{ required: true }]}
        required
      >
        <Select placeholder={t('global:select_option')}>
          {projectNatures?.map(({ label, value }: PickListValue) => (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item<ProjectInformationsFormType>
        rules={[{ required: true }]}
        required
        name={'usage'}
        label={t('add_dossier_project:usage')}
      >
        <Select placeholder={t('global:select_option')}>
          {projectUsages?.map(({ label, value }: PickListValue) => (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item<ProjectInformationsFormType>
        name={'operation'}
        label={t('add_dossier_project:operation')}
        rules={[{ required: true }]}
        required
      >
        <Select placeholder={t('global:select_option')}>
          {projectOperations?.map(({ label, value }: PickListValue) => (
            <Select.Option key={value} value={value}>
              {label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {operation === 'Ventilation' && (
        <Form.Item<ProjectInformationsFormType>
          name={'surfaceVentileeRehabilitee'}
          label={t('add_dossier_project:surfaceVentileeRehabilitee')}
        >
          <InputNumber className={'w-full'} min={0} />
        </Form.Item>
      )}
      {operation === 'Chauffage' && (
        <>
          <Form.Item<ProjectInformationsFormType>
            name={'ancienneEnergieChauffage'}
            label={t('add_dossier_project:ancienneEnergieChauffage')}
          >
            <Select placeholder={t('global:select_option')}>
              {previewsProjectEnergies?.map(
                ({ label, value }: PickListValue) => (
                  <Select.Option key={value} value={value}>
                    {label}
                  </Select.Option>
                ),
              )}
            </Select>
          </Form.Item>
          <Form.Item<ProjectInformationsFormType>
            name={'nouvelleEnergieChauffage'}
            label={t('add_dossier_project:nouvelleEnergieChauffage')}
          >
            <Select placeholder={t('global:select_option')}>
              {newProjectEnergies?.map(({ label, value }: PickListValue) => (
                <Select.Option key={value} value={value}>
                  {label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item<ProjectInformationsFormType>
            name={'surfaceChauffee'}
            label={t('surfaceChauffee')}
          >
            <InputNumber className={'w-full'} min={0} />
          </Form.Item>
          <Form.Item<ProjectInformationsFormType>
            name={'surfaceChauffeeRehabilitee'}
            label={t('surfaceChauffeeRehabilitee')}
          >
            <InputNumber className={'w-full'} min={0} />
          </Form.Item>
        </>
      )}
    </Form>
  );
}
